/**
 * The part of an url that identifies a page, with the query string and the
 * fragment dropped.
 *
 * Both carry values — filters, search terms, tokens, ids — so anything that
 * groups by page (analytics, chat context, logs) wants the route alone.
 */
export function stripUrlQueryAndFragment(url: string): string {
  return url.split(/[?#]/)[0] ?? '';
}
